/*
 * @Author: your name
 * @Date: 2021-09-15 15:46:14
 * @LastEditTime: 2021-09-15 15:47:14
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\api\Bus.js\bus.js
 */
import Vue from 'vue'
export default new Vue;


// WEBPACK FOOTER //
// ./src/api/bus/bus.js